import ninegrid from "../index.js";

import { ngCellCopyPasteKeyHandler } from "./ngCellCopyPaste.js";
import { ngPinManager } from "./ngRowPin.js";
import { ngFields } from "./ngFields.js";
import { ngCellManager } from "./ngCellManager.js";
import { ngCellTouchEvent } from "./ngCellTouchEvent.js";
import { ngCellSelection } from "./ngCellSelection.js";
import { ngTableManager } from "./ngTableManager.js";
import { ngDataManager } from "./ngDataManager.js";
import { ngView } from "./ngView.js";
import { ngTableWrapper } from "./ngTableWrapper.js";
import { ngColumns } from "./ngColumns.js";
import { ngSorting } from "./ngSorting.js";
import { ngMatrixManager } from "./ngMatrixManager.js";
import { ngColResizer } from "./ngColResizer.js";
import { ngColMover } from "./ngColMover.js";
import { ngRowMover } from "./ngRowDrag.js";
import { ngCustomEvent } from "./ngCustomEvent.js";

import { ngFiltering } from "../utils/ngFiltering.js";

export class NineGridContainer extends HTMLElement
{
	#created = false;
	#colResizer;
	#colMover;
	#rowMover;
	#layouts;

	constructor() {
		
		//console.log(ninegrid.cssPath);
		//ninegrid.cssPath = "/src/css";
		//ninegrid.setCssPath("/css/nine-grid");

		//console.log("ninegrid constructor()");

		

		super();
		
		this.attachShadow({ mode: 'open' });
		

		ninegrid.extendElementPrototype();
		
		this.#layouts = [];

		/**
		this.col = {
			toNum : (cols) => {
				if (!Array.isArray(cols)) cols = [cols];
				
				var arr = [];
				for (var col of cols) {
					arr.push(typeof col === "string" ? $(`[data-bind=${col}]`, this.template).attr("data-col") : col);
				}
				
				return arr;
			},
			clearMarking : (cols) => {
				for (var col of this.col.toNum(cols)) {
					$(`.col-indicator-rowgroup [data-col=${col}]`, this.body).attr("class", "col-indicator");
				}
			},
			marking : (cols, classNm) => {
				this.col.clearMarking(cols);
				for (var col of this.col.toNum(cols)) {
					$(`.col-indicator-rowgroup [data-col=${col}]`, this.body).addClass(classNm);
				}
			},
		}
		*/

		
		this.refreshBindRows = () => {
					
			this.bindRows			= [];
			this.bindMatrixRows	= [];
			
			ninegrid.j.querySelectorAll(".ng-container tbody.bindable tr:not(.nodata)", this.body).elements.forEach(tr => {
				this.bindRows		.push(parseInt(tr.dataset.row));
				this.bindMatrixRows	.push(parseInt(tr.dataset.matrixRow));
			});
			
			this.bindRows		= [...new Set(this.bindRows)];
			this.bindMatrixRows	= [...new Set(this.bindMatrixRows)];
			
			var lastTrs = $(`.ng-container-body tr[data-row="${this.bindRows[this.bindRows.length-1]}"]`, this.body);
			if (lastTrs.length  > 0) {
				var container	= $(".ng-container-body", this.body);
				var tfoot		= $("tfoot", container);
				var t			= lastTrs.eq(0).position().top;
				var h			= 0;
				
				lastTrs.each((i,tr) => { h += $(tr).height(); });

			}
			else {

			}
		};

		
		this.refresh = () => {
			this.refreshScroll();
		
			// sys/sub sys : sub sys(2nd. Tab) autofit 미작동
			//this.autoFitCol = this.autoFitCol;
			//this.setAttribute("auto-fit-col", this.getAttribute("auto-fit-col"));
		};
		
		this.refreshScroll = () => {
			// 이거하면 position이 relative로 됨
			//$('.ng-container .ng-table', this.body).offset({top:$('.ng-container .ng-table', this.body).offset().top});
		};
		
		this.setCurrCell = (nCell) => {
			this.currCell = nCell;
		};
	}
	
	connectedCallback() {
		
		//console.log("ninegrid connectedCallback()", this);
		
		$(() => { this.#initialize(); });
		document.addEventListener("DOMContentLoaded", e => {
			//this.#initialize();
		});
		
		$(document.body).on("mousedown", e => { if (!e.target.closest("ng-combo-panel")) $("ng-combo-panel").hide(); });
	}
	
	disconnectedCallback() {
		//console.log("Custom element removed from page.");
		//this.data.clear();
	}

	adoptedCallback() {
		//console.log("Custom element moved to new page.");
	}
	
	get currentRow() {
		return this.row.at;
	};
	
	get dataSource() {
		return this.dataManager.rawRecords;
	};
	set dataSource(v) {
		(this.dataManager) ? this.#setDataSource(v) : setTimeout(() => { this.#setDataSource(v); }, 300);
	}
	
	get layouts() {
		return this.#layouts;
	}
	
	static observedAttributes = ["lang","caption","display-row-count","row-resizable","col-indicator-type","auto-fit-col","enable-fixed-col","select-type","paging-type","paging-count","show-menu-icon","show-title-bar","show-tfoot","show-status-bar","auto-height"];
	attributeChangedCallback(name, oldValue, newValue) {
		
		switch (name) {
		case "lang":
			//if (this.langManager) this.langManager.reset();
			break;
			
		case "caption":
			const head = this.shadowRoot.querySelector("ng-head");
			if (head) $("span:first-child", head.shadowRoot.querySelector("ng-title")).html(v);
			break;
		
		case "display-row-count":
			this.lastRowHidden = isNaN(parseInt(newValue)) ? true : false;
			break;
			
		case "row-resizable":
			(newValue == "true") ? $(".row-resizer", this.shadowRoot).show() : $(".row-resizer", this.shadowRoot).hide();
			break;
			
		case "col-indicator-type":
			ninegrid.j.querySelectorAll(".ng-table thead .col-indicator-rowgroup", this.body)
				.removeClass(ninegrid.COLINDICATORTYPE.EXPAND).removeClass(ninegrid.COLINDICATORTYPE.COLLAPSE)
				.addClass(newValue);
			this.#resetHeight();
			break;
			
		case "auto-fit-col":
			if (this.#colResizer) this.#colResizer.autoFit(newValue == "true");
			this.#resetHeight();
			break;
		case "enable-fixed-col":
			(newValue == "true") ? ninegrid.j.querySelectorAll(this).addClass(name) : ninegrid.j.querySelectorAll(this).removeClass(name);
			break;
		
		case "select-type":
			if (this.selection) this.selection.type = newValue;
			break;
		case "paging-type":
			if (this.paging) this.paging.type = newValue;
			break;
		case "paging-count":
			if (this.paging) this.paging.count = newValue;
			break;
		
		case "show-menu-icon":
		case "show-title-bar":
			const showBar	= ninegrid.j.querySelectorAll(this).attr("show-title-bar") == "true";
			const showIcon	= ninegrid.j.querySelectorAll(this).attr("show-menu-icon") == "true";
			const ngHead	= this.shadowRoot.querySelector("ng-head");
			if (!ngHead) break;
			const ngMenu = ngHead.shadowRoot.querySelector("ng-menu");

			if (showBar) {
				ninegrid.j.querySelectorAll(ngHead).addClass('expand');
				$(ngHead.shadowRoot).children().not("style").show();
				
				if (!showIcon) ninegrid.j.querySelectorAll(ngMenu).hide();
			}
			else {
				(showIcon) ? ninegrid.j.querySelectorAll(ngHead).removeClass('expand').show() : ninegrid.j.querySelectorAll(ngHead).hide();
			}
			
			this.#resetHeight();
			break;
		
		case "show-tfoot":
			$("tfoot", this.body).css({ visibility : (newValue == "true" ? "unset" : "collapse") });
			this.#resetHeight();
			break;
		case "show-status-bar":
			(newValue == "true") ? ninegrid.j.querySelectorAll("ng-foot", this.shadowRoot).addClass('expand') : ninegrid.j.querySelectorAll("ng-foot", this.shadowRoot).removeClass('expand');
			this.#resetHeight();
			break;

		case "auto-height":
			if (newValue == "true") {
				this.classList.add("auto-height");
			} else {
				this.classList.remove("auto-height");
			}
			this.#resetHeight(); // 높이 관련 속성이 변했으므로 재계산 호출
			break;
		}
		
	}

	export = () => {
		const el = this.shadowRoot.querySelector("ng-export");

		if (el) {
			el.remove();
		}

		const newEl = document.createElement("ng-export");
		this.shadowRoot.appendChild(newEl);

		setTimeout(() => { // DOM에 추가된 후 실행 보장
			newEl.exportExcel();
		});
	};

	maximize = () => {
		const el = this.shadowRoot.querySelector("ng-max-popup");

		if (el) {
			el.remove();
		}

		const newEl = document.createElement("ng-max-popup");
		this.shadowRoot.appendChild(newEl);

		setTimeout(() => { // DOM에 추가된 후 실행 보장
			newEl.popup();
		});
	};


	refreshData = (v) => {
		if (v == null) {
			var rows = [];
			$(".ng-container-body tbody.bindable tr", this.body).not(".nodata").each((i, tr) => {
				rows.push(this.dataManager.viewRecords.rawIndex + parseInt(tr.sectionRowIndex / this.template.length));
			});

			rows = [...new Set(rows)];
			
			rows.forEach(row => {
				const data = this.data.get(row);
				this.body.querySelectorAll(`.ng-container tbody.bindable tr[data-row="${row}"]`).forEach(tr => {

					tr.data = data;
				});
			});
			
			var arr = [];
			$(".ng-container-body tbody.fixed tr", this.body).not(".nodata").each((i, tr) => {
				arr.push({ INDEX: tr.data.__ng._[ninegrid.ROW.INDEX], ROW: tr.dataset.row } );
			});

			arr.forEach(o => {
				const data = this.data.getNF(o.INDEX);
				this.body.querySelectorAll(`.ng-container tbody.fixed tr[data-row="${o.ROW}"]`).forEach(tr => {

					tr.data = data;
				});
			});
		}
		else {
			v = parseInt(v);
			const data = (v < 0) ? this.data.getNF(this.body.querySelector(`tbody.fixed tr[data-row="${v}"]`).dataset.index) : this.data.get(v);

			this.body.querySelectorAll(`.ng-container tbody tr[data-row="${v}"]`).forEach(tr => {
				tr.data = data;
			});
		}
		
		const target = (v == null) ? $(".ng-container tbody tr th,.ng-container tbody tr td", this.body) : $(`.ng-container tbody tr[data-row=${v}] th,.ng-container tbody tr[data-row=${v}] td`, this.body);
		target.each((i, td) => {
			if (td.children[0] && td.children[0].dataRefresh && td.dataset.row) {
				td.children[0].dataRefresh();
			}
		});
		
		$(".ng-container thead tr th,.ng-container thead tr td,.ng-container tfoot tr th,.ng-container tfoot tr td", this.body).each((i, td) => {
			if (td.children[0] && td.children[0].dataRefresh) {
				td.children[0].dataRefresh();
			}
		});
	};
	
	refreshDataV2 = () => {
		const target = $(".ng-container tbody tr th,.ng-container tbody tr td", this.body);
		target.each((i, td) => {
			if (td.children[0] && td.children[0].dataRefresh && td.dataset.row) {
				td.children[0].dataRefresh(true);
			}
		});

		$(".ng-container thead tr th,.ng-container thead tr td,.ng-container tfoot tr th,.ng-container tfoot tr td", this.body).each((i, td) => {
			if (td.children[0] && td.children[0].dataRefresh) {
				td.children[0].dataRefresh(true);
			}
		});
	};


	
	#setDataSource = (v) => {
		if (!this.dataManager) return;

		this.data.clear();
		
		this.dataManager.setDataSource(v);
		
		this.refresh();
		
		if (this.paging) this.paging.refresh();
		this.scrollTo_V1(0);
	}
	
	
	
	changeRayout = (index) => {
		
		/**
		if (!$("tbody", this.#layouts[index]).hasClass("fixed")) {
			
			//$("tbody", this.#layouts[index]).before($("tbody", this.#layouts[index]).clone().addClass("fixed")).addClass("bindable");

			$(ninegrid.j.querySelectorAll("tbody", this.#layouts[index]).addClass("bindable").elem()).before(`<tbody class="fixed"></tbody>`);
		} */
		
		$(".ng-container-left", this.body).children().remove();
		$(".ng-container-right", this.body).children().remove();
		$(".ng-container-body", this.body).children().remove();
		
		$(".ng-container-body", this.shadowRoot).append(this.#layouts[index]);

		this.#prepare();
		this.createTemplate();

		this.#init();
		
		this.resetTemplate();

		this.#initOption();
		
		this.cell.resetEvent();
		this.touchEvent.resetEvent();
		this.#colResizer.resetEvent();
		this.#colMover.resetEvent();
		
		if (this.#rowMover) this.#rowMover.resetEvent();
		if (this.sorting) this.sorting.initialize();
		if (this.filtering) this.filtering.initialize();
		if (this.pin) this.pin.initialize();
		
		this.data.initialize();



		/**
		 * layout 변경시 : setTimeout 미작성시 thead height 오류
		 */
		setTimeout(() => {
			if (this.paging) this.paging.refresh();
			this.scrollTo_V1(0);
		});
	};
	
	#init = () => {
		
		this.elements = {
			table		: $(this.body.querySelector(".ng-container-body > table")),
			hscrollbar	: $(this.body.querySelector("ng-hscrollbar")),
			vscrollbar	: $(this.body.querySelector("ng-vscrollbar")),
			bodyLeft	: $(this.body.querySelector(".ng-container-left")),
			bodyBody	: $(this.body.querySelector(".ng-container-body")),
			bodyRight	: $(this.body.querySelector(".ng-container-right")),
		};

		this.elements.table.show();
	
		var table = this.elements.table.clone();
		//table.find("colgroup").remove();
		
		this.elements.bodyLeft.html(table.clone());
		$("col,th,td", this.elements.bodyLeft).not("[fixed=left]").remove();
		var w = 0;//this.elements.bodyLeft.find("th,td").length == 0 ? 0 : this.elements.bodyLeft.find("table > tbody.bindable").width();
		$("col", this.elements.bodyLeft).each((i,el) => { w += parseInt(ninegrid.j.querySelectorAll(el).attr("width")); });
		this.elements.bodyLeft.css({
			"width"		: w,//this.elements.bodyLeft.find("table > tbody.bindable").width(),
			"min-width"	: w,//this.elements.bodyLeft.find("table > tbody.bindable").width(),
		});
		
		this.elements.bodyRight.html(table.clone());
		$("col,th,td", this.elements.bodyRight).not("[fixed=right]").remove();
		w = 0;//this.elements.bodyLeft.find("th,td").length == 0 ? 0 : this.elements.bodyLeft.find("table > tbody.bindable").width();
		$("col", this.elements.bodyRight).each((i,el) => { w += parseInt(ninegrid.j.querySelectorAll(el).attr("width")); });
		
		this.elements.bodyRight.css({
			"width"		: w,//this.elements.bodyRight.find("table > tbody").width(),
			"min-width"	: w,//this.elements.bodyRight.find("table > tbody").width(),
		});
	
	
		this.elements.bodyBody.html(table.clone());
		this.elements.bodyBody.find("[fixed=left]").remove();
		this.elements.bodyBody.find("[fixed=right]").remove();
		
		this.elements.bodyLeft	.find("tbody tr").remove();
		this.elements.bodyRight	.find("tbody tr").remove();
		this.elements.bodyBody	.find("tbody tr").remove();
		
		this.elements.bodyBody.find("table").width(0);
		//this.elements.bodyBody.find("table").width(parseInt(this.elements.table.width() - lw));


		if ($('.ng-container .ng-table tr.nodata', this.body).length <= 0) {
			var trTmpl = '<tr class="nodata"></tr>';

			this.elements.bodyLeft	.find("tbody.bindable").append(trTmpl);
			this.elements.bodyRight	.find("tbody.bindable").append(trTmpl);
			this.elements.bodyBody	.find("tbody.bindable").append(trTmpl);
			/**
			var h = $(".ng-container-body", this.body).height() - $(".ng-container-body .ng-table", this.body).height() + $('.ng-container-body .ng-table tr.nodata', this.body).height();
			
			$(".ng-container tbody.bindable tr.nodata", this.body).each((i, tr) => {
				$(tr).height(h);
			}); */
		}

	};
	
	#templateHeight = () => {
		if (!this.template) return 0;
		
		var h = 0;
		this.template.each((i,tr) => {
			h += $(tr).height();
		});
	
		return h;
	};
	
	#resetHeight = () => {


		const rowCount = parseInt(this.getAttribute("display-row-count"));

		if (isNaN(rowCount)) return;
		
		const ngHead = this.shadowRoot.querySelector("ng-head");
		if (!ngHead) return;
		
		setTimeout(() => {
	
			const paddingBottom = parseInt(window.getComputedStyle(ngHead).getPropertyValue("padding-bottom"), 10);

			
			var h =
				($(ngHead).height() || 0) +
				($("ng-foot", this.shadowRoot).height() || 0) +
				($(".ng-container-body thead", this.shadowRoot).height() || 0) +
				($(".ng-container-body tfoot:visible", this.shadowRoot).height() || 0) +
				($(".ng-container-bottom:visible", this.shadowRoot).height() || 0) +
				paddingBottom +
				(this.#templateHeight() || 0) * rowCount +
				3;

			$(this).height(h);


			//console.log(this, h);

			//$(this).height(600);
		});
	};
	
	#initialize = () => {

		if (this.#created) return;

		this.originFormat = this.outerHTML;
		
		this.uuid = ninegrid.randomUUID();	//crypto.randomUUID();
		if (!this.id) this.id = this.uuid;
		
		
		$("table", this).each((i,tbl) => {
			
			if ($("colgroup", tbl).length == 0) {

				var colCount = 0;
				$("tbody tr", tbl).eq(0).find("th,td").each((i,el) => {
					colCount += el.colSpan || 1;
				});

				$(tbl).prepend("<colgroup></colgroup>");
				
				var w = Math.max(parseInt(($(tbl).width() - 16) / colCount) - 1, 100);
				for (var i = 0; i < colCount; i++) {
					$("colgroup", tbl).append(`<col width="${w}" />`);
				}
			}
			
			if (!tbl.querySelector("thead")) {
				$("colgroup", tbl).after("<thead></thead>");
			}


			$("tbody th,tbody td", tbl).each((i,el) => {
				//$(el).css({"display":"flex",});
				if (el.innerHTML.trim() == "") {
					el.innerHTML = "<ng-renderer>";
				}
			});
			
			$("thead th,thead td,tfoot th,tfoot td", tbl).each((i,el) => {
				if (el.dataset && el.dataset.expr) el.innerHTML = "<ng-renderer>";
				if (!el.getAttribute("title")) el.setAttribute("title", el.innerHTML);
			});
			
			/**
			 * datalist가 선언되었으면 dataSource, data-expr을 정의한다.
			 */
			/** */
			$("datalist_BAK", tbl).each((i,datalist) => {
				if (datalist.parentNode.getAttribute("data-source")) return true;


				const ds = [];
				datalist.querySelectorAll("option").forEach(option => {
					
					var o = {};
					for (var i = 0; i < option.attributes.length; i++) {
						o[option.attributes[i].name] = option.attributes[i].value;
					}
					ds.push(o);
				});
				
				
				/**
				 * 상세창 오픈시 window[this.id] = null;
				 */
				if (!window[this.id]) window[this.id] = this;
				window[this.id]["code"+i] = ds;
				

				const cell = datalist.closest("th,td");
				if (cell) {
					const key			= cell.getAttribute("key") || "key";
					const value			= cell.getAttribute("value") || "value";
					const multiSeparator= cell.getAttribute("multi-separator") || ",";

					var dataSource = `window["${this.id}"]["code${i}"]`;
					datalist.parentNode.setAttribute("data-source", dataSource);
					cell.dataset.expr = `ninegrid.binarySearchValue(${dataSource}, "${key}", data["${cell.dataset.bind}"].split("${multiSeparator}"), "${value}")`;
				}
			});

			$(tbl).hide();

			this.#layouts.push(tbl);
			
			if (!ninegrid.j.querySelectorAll(this).hasClass("simple")) {
				this.#createDummy(tbl);
			}
		});

		//const baseUrl = `@import "https://cdn.jsdelivr.net/npm/@ninebone/grid@${__APP_VERSION__}/dist/css/ninegrid.css"`;
		const customUrl = nine.cssPath ? `@import "${nine.cssPath}/ninegrid/ninegrid.css";` : "";

		const tmpl = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/@ninebone/grid@${__APP_VERSION__}/dist/css/ninegrid.css";
				${customUrl}
			</style>
			
			<ng-head></ng-head>
			<div class='ng-background'></div>
			<div class='ng-body'>
				<div class='ng-etc1'></div>
				<div class='ng-container'>
					<div class='ng-container-top'>
						<div class='ng-container-left'></div>
						<div class='ng-container-body'></div>
						<div class='ng-container-right'></div>
						<ng-vscrollbar></ng-vscrollbar>
					</div>
					<div class='ng-container-bottom'>
						<ng-hscrollbar></ng-hscrollbar>
						<div class='ng-scroll-edge'></div>
					</div>
				</div>
				<div class='ng-etc2'></div>
			</div>
			<ng-foot></ng-foot>
		`;
	
		
		this.comboExpr = (data,currow,cell) => {
			const combo = cell.querySelector("ng-combo");
			if (!combo) return "";
			
			const code				= combo.getAttribute("code") || "code";
			const value				= combo.getAttribute("codename") || "codename";
			const multiSeparator	= combo.getAttribute("multi-separator") || ",";
			
			return ninegrid.binarySearchValue(combo.dataSource, code, data[cell.dataset.bind], value, multiSeparator)
		};
		//$("tbody", this.#layouts[0]).before($("tbody", this.#layouts[0]).clone().addClass("fixed")).addClass("bindable");
		
		for (const layout of this.#layouts) {
			$(ninegrid.j.querySelectorAll("tbody", layout).addClass("bindable").elem()).before(`<tbody class="fixed"></tbody>`);
		}

		$(this.shadowRoot).append(tmpl);
		
		//console.log(this.#layouts[0], $("tbody", this.#layouts[0])[0]);

		
		$(".ng-container-body", this.shadowRoot).append(this.#layouts[0]);
		this.body = this.shadowRoot.querySelector(".ng-body");
		

		//this.querySelectorAll("buttons *").forEach(v => {v.grid = this;});
		this.querySelectorAll("nx-buttons *").forEach(v => {v.grid = this;});
		$(this.shadowRoot.querySelector("ng-head").shadowRoot.querySelector("ng-custom")).append(this.querySelectorAll("nx-buttons"));

		this.#prepare();

		this.createTemplate();
		
		this.#init();

		this.resetTemplate();
		
		this.#createObserver();
		
		const foot = this.shadowRoot.querySelector("ng-foot");
		
		this.paging = foot.shadowRoot.querySelector("ng-paging");
		this.layout = foot.shadowRoot.querySelector("ng-layout");
		if (this.layout) {
			this.layout.add(this.#layouts);
		}

		new ngCellCopyPasteKeyHandler(this);
		

		//this.langManager = new ngLangManager(this);
		this.pin = new ngPinManager(this);
		
		this.fields = new ngFields(this);
		
		this.cell = new ngCellManager(this);
		this.touchEvent = new ngCellTouchEvent(this);
		
		this.selection = new ngCellSelection(this);
		this.tables = new ngTableManager(this);
		this.dataManager = new ngDataManager(this);
		
		this.view = new ngView(this);
		//this.tableUtils = this.querySelector(".ng-container"); // 위로
		this.tableUtils = new ngTableWrapper(this);
		//this.dataManager.setdataManager([]);
		
		this.columns = new ngColumns(this);
		
		for (var s in this.dataManager) {		// 함수 복사
			if (this.dataManager[s] instanceof Function && !["xxx"].includes(s)) {
				this[s] = this.dataManager[s].bind(this);
			} else if (["data","row","tree"].includes(s)) {
				this[s] = this.dataManager[s];
			}
		}
		
		for (var s in this.tableUtils) {		// 함수 복사
			if (["columns"].includes(s)) {
				this[s] = this.tableUtils[s];
			}
		}
		for (var s in this.cell) {		// 함수 복사
			if (this.cell[s] instanceof Function && !["refresh"].includes(s)) {
				//this[s] = this.selection[s].bind(this);

			} else if (["xx"].includes(s)) {

				this[s] = this.cell[s];
			}
		}
		
		if (!ninegrid.j.querySelectorAll(this).hasClass("simple")) {
			this.filtering = new ngFiltering(this);
		}
		if (!ninegrid.j.querySelectorAll(this).hasClass("combo") && !ninegrid.j.querySelectorAll(this).hasClass("filter")) {
			$(this.shadowRoot).append($('<ng-combo-panel></ng-combo-panel').hide());
		}
		
		this.sorting = new ngSorting(this);

		this.matrix = new ngMatrixManager(this);

		this.#colResizer = new ngColResizer(this);
		this.#colMover = new ngColMover(this);
		if (!ninegrid.j.querySelectorAll(this).hasClass("simple")) this.#rowMover = new ngRowMover(this);
		
		
		this.#initOption();
		
		this.refresh();
		
		
		/** combo, filtering tr */
		/**
		$(".simple .ng-table tbody", this.body).on("mouseover", "tr", e => {
			//$(`.ng-table tbody tr[data-row=${e.target.closest('tr').dataset.row}]`, this.body).addClass("hover");
			ninegrid.j.querySelectorAll(`.ng-table tbody tr[data-row="${e.target.closest('tr').dataset.row}"]`, this.body).addClass("hover");
		});
		
		$(".simple .ng-table tbody", this.body).on("mouseout", "tr", (e) => {
			//$(`.ng-table tbody tr[data-row=${e.target.closest('tr').dataset.row}]`, this.body).removeClass("hover");
			ninegrid.j.querySelectorAll(`.ng-table tbody tr[data-row="${e.target.closest('tr').dataset.row}"]`, this.body).removeClass("hover");
		});
		*/
		
		if (this.body.querySelector(".ng-container-body .nodata")) {
			new ResizeObserver((entries, observer) => {
				this.body.querySelector("ng-vscrollbar").refresh();
			}).observe(this.body.querySelector(".ng-container-body .nodata"));
		}
		
		
		/** main, detail */
		if (!ninegrid.j.querySelectorAll(this).hasClass("filter") && !ninegrid.j.querySelectorAll(this).hasClass("combo")) {

			/**
			$(this).on("mousedown", e => {

				e.target.shadowRoot.querySelectorAll("ng-context-menu-panel,ng-filter-panel").forEach(el => {
					
					if ($(el).is(":visible")) $(el).hide();
				});
			}); */
			
			$(this.body).on("mousedown", e => {
				this.shadowRoot.querySelectorAll("ng-combo-panel,ng-filter-panel,ng-context-menu-panel").forEach(el => {
					if ($(el).is(":visible")) $(el).hide();
				});
			});
			
			$(this).on("click", e => {
				e.target.shadowRoot.querySelectorAll("ng-info").forEach(el => {
					el.close();
				});
			});
		}
		
		new ngCustomEvent(this);

		
		/**
		 * 아래 ninegrid.EVENT.LOAD 랑 중복되는 코드인 것 같음.
		 */
		/**
		if (!this.classList.contains("simple")) {
			if (this.getAttribute("onLoad")) {
				this.exprFunction(this.getAttribute("onLoad")).call(this);
			}
		} */
		if (!this.classList.contains("simple")) {
			setTimeout(() => {
				this.dispatchEvent(new CustomEvent(ninegrid.EVENT.LOAD, { bubbles: true, detail: {} }));
			}, 100);
		}
		
		const head = this.shadowRoot.querySelector("ng-head");
		if (head) {
			//head.shadowRoot.querySelectorAll("buttons button").forEach(el => {
			head.shadowRoot.querySelectorAll("nx-buttons button").forEach(el => {
				el.addEventListener("click", e => {
					const ce = new CustomEvent(ninegrid.EVENT.BUTTON_CLICK, { bubbles: true, detail: { target: el, } });
					//ce.target = e.target;
					this.dispatchEvent(ce);
				});

			});
		}
		/**

		//this.addEventListener('load', e => {  });
		

		this.onload = new CustomEvent('load', { bubbles: true, detail: {} });
		this.onload.data = {"x":"x","Y":"Y"};
		this.dispatchEvent(this.onload);
		
		
		//$(".ng-table tbody",			this.body).on("click",		"th,td",	new CustomEvent('cellclick', { bubbles: true, detail: {} }));
		$(".ng-table tbody",			this.body).on("click",		"th,td",	e => { this.dispatchEvent(this.onload); } );
		
		for (var handler of this.#handlers) {

			this.addEventListener(handler.type, handler.listener);
		} */

		this.#created = true;
	};
	
	#initOption = () => {
		
		this.lastRowHidden = isNaN(parseInt(ninegrid.j.querySelectorAll(this).attr("display-row-count")));
		
		if (!this.paging) this.paging = {};	//row detail 팝청창 오픈시 오류

		ninegrid.j.querySelectorAll(this).attr("col-indicator-type",	ninegrid.j.querySelectorAll(this).attr("col-indicator-type")	|| ninegrid.COLINDICATORTYPE.COLLAPSE);

		ninegrid.j.querySelectorAll(this).attr("auto-fit-col",		ninegrid.j.querySelectorAll(this).attr("auto-fit-col")		|| "false");
		ninegrid.j.querySelectorAll(this).attr("col-resizable",		ninegrid.j.querySelectorAll(this).attr("col-resizable")		|| "true");
		ninegrid.j.querySelectorAll(this).attr("row-resizable",		ninegrid.j.querySelectorAll(this).attr("row-resizable")		|| "false");
		ninegrid.j.querySelectorAll(this).attr("col-movable",		ninegrid.j.querySelectorAll(this).attr("col-movable")		|| "false");	//web attribute
		//ninegrid.j.querySelectorAll(this).attr("row-movable",		ninegrid.j.querySelectorAll(this).attr("row-movable")		|| "false");
		ninegrid.j.querySelectorAll(this).attr("enable-fixed-col",	ninegrid.j.querySelectorAll(this).attr("enable-fixed-col")	|| "false");

		ninegrid.j.querySelectorAll(this).attr("show-title-bar",		ninegrid.j.querySelectorAll(this).attr("show-title-bar")		|| "false");
		ninegrid.j.querySelectorAll(this).attr("show-menu-icon",		ninegrid.j.querySelectorAll(this).attr("show-menu-icon")		|| "false");
		ninegrid.j.querySelectorAll(this).attr("show-status-bar",	ninegrid.j.querySelectorAll(this).attr("show-status-bar")	|| "false");
		
		ninegrid.j.querySelectorAll(this).attr("show-thead",			ninegrid.j.querySelectorAll(this).attr("show-thead")			|| "true");
		ninegrid.j.querySelectorAll(this).attr("show-tfoot",			ninegrid.j.querySelectorAll(this).attr("show-tfoot")			|| "true");
		
		ninegrid.j.querySelectorAll(this).attr("select-type",		ninegrid.j.querySelectorAll(this).attr("select-type")		|| ninegrid.SELECTTYPE.CELL);
		ninegrid.j.querySelectorAll(this).attr("paging-type",		ninegrid.j.querySelectorAll(this).attr("paging-type")		|| ninegrid.PAGINGTYPE.NONE);
		ninegrid.j.querySelectorAll(this).attr("paging-count",		ninegrid.j.querySelectorAll(this).attr("paging-count")		|| ninegrid.PAGINGCOUNT.AUTO);

		this.setAttribute("auto-height", this.getAttribute("auto-height") || "false");
	};
	
	#createObserver = () => {
				
		//this.io = new ngIntersectionObserver(this);
		
		new ResizeObserver(e => {
			if (this.view) this.view.redraw();
			this.refreshScroll();
			
			this.refreshBindRows();

			if ($("tbody.bindable tr:not([data-matrix-row])", this.body).not('.nodata').length > 0) {
				this.dataManager.viewRecords.reset();
			}
		}).observe(this);
		
		const mutationObserver = new MutationObserver((entries, observer) => {
			this.body.querySelector("ng-hscrollbar").refresh();
		});
		
		$("colgroup", this.body).each((i,el) => {
			mutationObserver.observe(el, {
				childList: true,
				subtree: true,
				attributeOldValue: true,
			});
		});
		
		this.body.querySelector("ng-hscrollbar").refresh();
		
		new ResizeObserver((entries, observer) => {

			if (this.getAttribute("auto-fit-col") == "true") {
				let prevWidth = [];
				var totalWidth = 0;

				$(".ng-container-body col", this.body).each((i,el) => { prevWidth.push({ col: el, width: Number(ninegrid.j.querySelectorAll(el).attr("width")), }); });
				prevWidth.forEach(o => { totalWidth += o.width; });
		
				//$('.ng-container-body > table', this.body).css({ "width": "100%", "min-width": "100%", });
				const tableWidth = $('.ng-container-body', this.body).width();
				
				if (tableWidth != 0) {
					prevWidth.forEach(o => { var w = o.width * tableWidth / totalWidth; ninegrid.j.querySelectorAll(o.col).attr("width", w); });
				}
			}
			
			this.body.querySelector("ng-hscrollbar").refresh();
			const layout = this.shadowRoot.querySelector("ng-foot").shadowRoot.querySelector("ng-layout");
			if (layout) {
				layout.resize();
			}
			
			
			this.#resetHeight();
			
		}).observe(this.body.querySelector(".ng-container-body"));
	};
	
	createTemplate = () => {
	
		this.template = $(".ng-container-body tbody.bindable tr:not(.nodata)", this.body).clone();
		this.tmpl = this.body.querySelectorAll(".ng-container-body tbody.bindable tr:not(.nodata)");
		this.activeTmpl = this.body.querySelector(".ng-container-body tbody.bindable tr:not(.nodata)");
	};

			
			
	resetTemplate = () => {
		
		var colIndex = 0;
		["left","body","right"].forEach(group => {
			$(`.ng-container-${group} colgroup col`, this.body).each((i,col) => {
				col.dataset.col = colIndex++;
			});
		});
		
		var cols = [];
		$(".col-indicator", this.body).each((i,td) => {
			cols.push({from: parseInt(td.dataset.col), to: i});
			td.innerHTML = `<div>${ninegrid.num2ExcelCol(i)}</div>`;
		});
		
		
		this.template.find("th,td").each((i,td) => {
			const index = cols.findIndex(m => m.from == td.dataset.col);
			if (index >= 0) td.dataset.col = cols[index].to;
		});

		$(".ng-table th,.ng-table td", this.body).each((i,td) => {
			const index = cols.findIndex(m => m.from == td.dataset.col);
			if (index >= 0) td.dataset.col = cols[index].to;
		});

		const layout = this.shadowRoot.querySelector("ng-foot").shadowRoot.querySelector("ng-layout");
		if (layout) {
			$("th,td", layout.currentTable).each((i,td) => {
				const index = cols.findIndex(m => m.from == td.dataset.col);
				if (index >= 0) td.dataset.col = cols[index].to;
			});
	
			$(".last", layout.currentTable).each((i,td) => {
				ninegrid.j.querySelectorAll(td).addClass("dummy");
			});
		}
		
		this.template.find(".last").each((i,td) => {
			ninegrid.j.querySelectorAll(td).addClass("dummy");
		});
		$(".last", this.body).each((i,td) => {
			ninegrid.j.querySelectorAll(td).addClass("dummy");
		});
	};

	#resetColIndex = (tbl, group) => {
		var tr = $(group + " tr", tbl);
		var td = $(group + " th," + group + " td", tbl);
		
		var rowCount = tr.length;
		var colCount = 0;
		td.each((i,el) => { colCount += el.colSpan; });
		
		var arr = Array.from(Array(rowCount), () => Array(colCount).fill(null));

		tr.each((index,el) => {
			var row = el.sectionRowIndex;
			var col = 0;

			$(el).find("th,td").each((index,td) => {
				
				for (var i = 0; i < arr[row].length; i++) {
					if (arr[row][i] == null) {
						col = i;
						break;
					}
				}
				
				for (var i = 0; i < td.rowSpan; i++) {
					for (var j = 0; j < td.colSpan; j++) {
						try {
							arr[row+i][col+j] = (i == 0 && j == 0) ? "1" : "0";
						} catch (e) { console.error(e); }
					}
				}
			});
		});

		
		tr.each((index,el) => {
			var row = el.sectionRowIndex;
			
			$(el).find("th,td").not(".dummy").each((index,td) => {
		
				for (var i = 0; i < arr[row].length; i++) {
					if (arr[row][i] == "1") {
						td.dataset.col = i;
						arr[row][i] = "0";
						break;
					}
				}
			});
		});
	};
	
	#createColIndicator = () => {
		
		const tdTmpl = `<th data-col="@col" class="col-indicator" scope="col"><div>@text</div></th>`;
		
		var thead = this.body.querySelector(".ng-container-body > table > thead");
		if (!thead) {

			return;
		}
		
		if (thead.querySelector(".col-indicator-rowgroup")) return;
		
		const tr = ninegrid.j.querySelectorAll(thead.insertRow(0)).attr("role", "row").addClass("col-indicator-rowgroup").elem();
		var cnt = 0;

		$(".ng-container-body > table > tbody.bindable > tr", this.body).eq(0).find("th,td").each((index, td) => {
			
			if (!ninegrid.j.querySelectorAll(td).hasClass("dummy")) {
				for (var i = 0; i < td.colSpan; i++) {
					$(tr).append(tdTmpl.replace("@col", cnt).replace("@text", ninegrid.num2ExcelCol(cnt++)));
				}
			}
		});
		
		var t = [];
		$("colgroup col", this.body).each((i,el) => { t.push({ width: parseInt(ninegrid.j.querySelectorAll(el).attr("width")), background: ninegrid.j.querySelectorAll(el).attr("background-color")} ); });
		$("thead .col-indicator", this.body).each((i,el) => { if (!t[i]) return false; $(el).css({ "width": t[i].width, "min-width": t[i].width, "background-color": t[i].background, "border-top-color": t[i].background, }); ninegrid.j.querySelectorAll(el).attr("background-color", t[i].background); });
	}
	
	#prepare = () => {
		
		/**
		var table = $(".ng-container-body > table", this.body);

		
		$("tbody tr", table).each((i,tr) => {

			//if (!tr.style.height) tr.style.height = "32px";
			if (!tr.style.height) {
				tr.style.height = "32px";//getComputedStyle(tr).height;
			}
		});
		
		
		var thead = $("thead", table);

		if (thead.length <= 0) $('<thead></thead>').appendTo(table);
		
		table.attr("role", "table")		.addClass("ng-table");
		
		table.find("tbody th,tbody td") .attr("tabindex", 0);

		table.find("thead,tbody,tfoot")	.attr("role", "rowgroup");
		table.find("tr")				.attr("role", "row");
		table.find("tbody > tr")		.attr("role", "gridcell");
		table.find("th,td")				.attr("scope", "col");

		this.#resetColIndex(table, "thead");
		this.#resetColIndex(table, "tbody.bindable");
		this.#resetColIndex(table, "tbody.fixed");
		this.#resetColIndex(table, "tfoot");
		
		this.#createColIndicator();
		
		table.find("col").each((i,el) => {
			table.find(`[data-col=${i}]`).attr("fixed", $(el).attr("fixed"));
		});
		*/
		var table = this.body.querySelector(".ng-container-body > table");
		if (!table) return;

		table.querySelectorAll("tbody tr").forEach(tr => {

			//if (!tr.style.height) tr.style.height = "32px";
			if (!tr.style.height) {
				tr.style.height = "32px";//getComputedStyle(tr).height;
			}
		});
		
		var thead = table.querySelector("thead");

		if (thead.length <= 0) $('<thead></thead>').appendTo(table);
		
		ninegrid.j.querySelectorAll(table).attr("role", "table")		.addClass("ng-table");
		
		ninegrid.j.querySelectorAll("tbody th,tbody td", table)	.attr("tabindex", 0);
		ninegrid.j.querySelectorAll("thead,tbody,tfoot", table)	.attr("role", "rowgroup");
		ninegrid.j.querySelectorAll("tr", table)					.attr("role", "row");
		ninegrid.j.querySelectorAll("tbody > tr", table)			.attr("role", "gridcell");
		ninegrid.j.querySelectorAll("th,td", table)				.attr("scope", "col");

		this.#resetColIndex($(table), "thead");
		this.#resetColIndex($(table), "tbody.bindable");
		this.#resetColIndex($(table), "tbody.fixed");
		this.#resetColIndex($(table), "tfoot");
		
		this.#createColIndicator();
		
		table.querySelectorAll("col").forEach((el,i) => {
			ninegrid.j.querySelectorAll(`[data-col="${i}"]`, table).attr("fixed", ninegrid.j.querySelectorAll(el).attr("fixed"));
		});
	}
	
	#createDummy = (tbl) => {

		this.#resetColIndex(tbl, "thead");
		this.#resetColIndex(tbl, "tbody");
		this.#resetColIndex(tbl, "tfoot");

		const createDummyCol = (cols, tmpl) => {
			(cols.length > 0) ?  $(tmpl).insertAfter($(cols[cols.length - 1])) : $('colgroup', tbl).prepend(tmpl);
		}
		
		const getLastTD = (tr, index) => {
			var rtn;
			
			$(`th,td`, tr).each((i, td) => {
				if (parseInt(td.dataset.col) >= index) {
					rtn = td;
					return false;
				}
			});
			
			return rtn;
		}
		
		//createDummyCol(tbl.querySelectorAll('col[fixed=left]'), '<col width="0" fixed="left" class="dummy" />');
		
		var index = $("colgroup col[fixed=left]", tbl).index($(".dummy[fixed=left]", tbl));

		$("tr", tbl).each((i, tr) => {
			//$('<td class="dummy"></td>').insertBefore(getLastTD(tr, index));
		});
		

		$('colgroup', tbl).prepend('<col width="0" fixed="left" class="first" />');
		
		$("tr", tbl).each((i, tr) => {
			$(tr).prepend('<td class="first"></td>');
		});
		
		$('colgroup', tbl).append('<col width="0" fixed="right" class="last" />');
		
		$("tr", tbl).each((i, tr) => {
			$(tr).append('<td class="last"></td>');
		});
	};
	
	#getTemplateCols = () => {
		var cols = [];
		$(`th,td`, this.template).not(".dummy").not(".first").each((i,el) => { if (!el.querySelector("ng-row-indicator")) cols.push(Number(el.dataset.col)); });
		return cols;
	};
	
	get firstCol() {
		return Math.min.apply(null, this.#getTemplateCols());
	};
	
	get lastCol() {
		return Math.max.apply(null, this.#getTemplateCols());
	};
	
	
	/**
	 * 다수의 셀을 선택합니다.
	 * 
	 * nRow1 : 선택할 데이타 행 시작 인덱스, 그리드 상에 보여지는 순서를 따릅니다. 또는 데이타 검색함수
	 * oCol1 : 선택할 컬럼 시작 인덱스 (1부터 시작) 또는 데이타의 컬럼명
	 * nRow2 : 선택할 데이타 행 마지막 인덱스, 그리드 상에 보여지는 순서를 따릅니다. 또는 데이타 검색함수
	 * oCol2 : 선택할 컬럼 마지막 인덱스 (1부터 시작) 또는 데이타의 컬럼명
	 * 
	 * return : 없음
	 */
	selectArea = (nRow1, oCol1, nRow2, oCol2) => {
			
		const row1		= this.#getRowIndex(nRow1);
		const row2		= this.#getRowIndex(nRow2);
		const col1		= this.#getColIndex(oCol1);
		const col2		= this.#getColIndex(oCol2);
		const matrixRow1= parseInt(row1 * this.template.length);
		const matrixRow2= parseInt(row2 * this.template.length) + this.template.length - 1;
		
		this.row.at = row1;
		
		(row1 >= 0 && row2 >= 0) ? this.selection.selectArea(matrixRow1, col1, matrixRow2, col2) : this.clearSelection();
	};
	
	/**
	 * 특정 행을 선택합니다.
	 * 
	 * nRow1 : 선택할 데이타 행 시작 인덱스, 그리드 상에 보여지는 순서를 따릅니다. 또는 데이타 검색함수
	 * nRow2 : 선택할 데이타 행 마지막 인덱스, 그리드 상에 보여지는 순서를 따릅니다. 또는 데이타 검색함수
	 * 
	 * return : 없음
	 */
	selectRow = (nRow1, nRow2) => {
			
		const row1		= this.#getRowIndex(nRow1);
		const row2		= ninegrid.isNull(oRow2) ? row1 : this.#getRowIndex(nRow2);
		const matrixRow1= parseInt(row1 * this.template.length);
		const matrixRow2= parseInt(row2 * this.template.length) + this.template.length - 1;
		
		this.row.at = row1;
		
		(row1 >= 0 && row2 >= 0) ? this.selection.selectArea(matrixRow1, this.firstCol, matrixRow2, this.lastCol) : this.clearSelection();
	};
	
	
	/**
	 * 특정 컬럼 전체를 선택합니다.
	 * 
	 * oCol1 : 선택할 컬럼 시작 인덱스 (1부터 시작) 또는 데이타의 컬럼명
	 * oCol2 : 선택할 컬럼 마지막 인덱스 (1부터 시작) 또는 데이타의 컬럼명
	 * 
	 * return : 없음
	 */
	selectCol = (oCol1, oCol2) => {
		const col1		= this.#getColIndex(oCol1);
		const col2		= ninegrid.isNull(oCol2) ? col1 : this.#getColIndex(oCol2);
		const matrixRow1= 0;
		const matrixRow2= parseInt(this.data.count() * this.template.length - 1);

		(col1 >= 0 && col2 >= 0) ? this.selection.selectArea(matrixRow1, col1, matrixRow2, col2) : this.clearSelection();
	};
	
	/**
	 * 특정 셀을 선택합니다.
	 * 
	 * nRow : 데이타 행 인덱스, 그리드 상에 보여지는 순서를 따릅니다. 또는 데이타 검색함수
	 * oCol : 컬럼 인덱스 (1부터 시작) 또는 데이타의 컬럼명
	 * nSubrow : tbody가 2개 이상의 tr로 디자인된 그리드인 경우 tr 인덱스
	 * 
	 * return : 없음
	 */
	selectCell = (nRow, oCol, nSubrow) => {
		
		const row		= this.#getRowIndex(nRow);
		const col		= this.#getColIndex(oCol);
		const matrixRow	= parseInt(row * this.template.length) + ninegrid.nvl(nSubrow, 0);
		
		this.row.at = row;
		
		(row >= 0) ? this.selection.selectArea(matrixRow, col, matrixRow, col) : this.clearSelection();
	};
	
	#getRowIndex = (oRow) => {
		if (typeof oRow === "number") {
			return oRow;
		}
		else if (typeof oRow === "function") {
			return this.data.findIndex(oRow);
		}
		else {
			throw `invalid ${oRow}`;
		}
	};
	
	#getColIndex = (oCol) => {
		if (typeof oCol === "number") {
			return oCol;
		}
		else if (typeof oCol === "string" && this.fields.includes(oCol)) {
			return  parseInt($(`[data-bind="${oCol}"]`, this.template)[0].dataset.col);
		}
		else {
			throw `invalid ${oCol}`;
		}
	};
	
	/**
	 * 그리드 행 위치를 이동합니다. (정리가 필요)
	 * 
	 * at : 이동할 행 위치
	 */
	scrollTo = (at) => {
		this.row.at = at;
		//if (col1 != null && col2 != null) this.selectArea(at, this.selction.firstCol, at, this.selction.lastCol);
	}
	
	/**
	 * 그리드 행 위치를 이동합니다.
	 * 
	 * nRow : 스크롤 할 행의 수를 지정합니다. Specifies the number of rows to scroll.
	 */
	scrollBy = (nRow) => {
		return this.dataManager.scrollTo_V1(this.dataManager.viewRecords.rawIndex + nRow);
	};
	
	/**
	 * 행 위치를 처음으로 이동합니다.
	 */
	scrollFirst = () => {
		this.scrollTo(0);
	}
	
	/**
	 * 행 위치를 마지막으로 이동합니다.
	 */
	scrollLast = () => {
		this.scrollTo(this.data.count() - 1);
	}
}

//export { NineGridContainer };

if (!customElements.get('nine-grid')) {
	customElements.define("nine-grid", NineGridContainer);
}

export class NineGridSourceContainer extends NineGridContainer
{
	constructor() {

		super();
	}

	connectedCallback() {
		super.connectedCallback();
	};
}

if (!customElements.get('ng-source')) {
	customElements.define("ng-source", NineGridSourceContainer);
}